import { useEffect } from "react";

const SecurityProtection = () => {
  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    const handleKeyDown = (e) => {
      const key = e.key.toLowerCase();

      // Block common shortcuts
      if (e.ctrlKey && ["c", "s", "u", "p", "a", "o"].includes(key)) {
        e.preventDefault();
      }

      // Block DevTools shortcuts
      if (
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && ["i", "j", "c"].includes(key))
      ) {
        e.preventDefault();
      }

      // Optional: Block PrintScreen (not reliable)
      if (e.key === "PrintScreen") {
        try {
          navigator.clipboard.writeText("");
        } catch (err) {
          // silently fail
        }
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return null;
};

export default SecurityProtection;
